var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.types),function(type,idx){return _c('v-btn',{key:idx,class:[
      'btn-primary-momentos-security',
      'text-12-security',
      { 'btn-active-momentos-security': type === _vm.category }
    ],attrs:{"id":type},on:{"click":function($event){return _vm.$emit('type', type)}}},[_vm._v(" "+_vm._s(type)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }